export default __webpack_public_path__ + "static/media/svg-Docs.229c8d85.svg";